import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import { translate } from 'utils/translations'
import * as Styled from './styled'
import { T } from 'consts/translationKeys'

const ExportButtonDisabled: React.FC = () => {
  return (
    <div>
      <Styled.ExportButtonWrapper $isDisabled={true}>
        {translate(T.EXPORT_LABEL)}
        <ArrowDownIcon />
      </Styled.ExportButtonWrapper>
    </div>
  )
}

export default ExportButtonDisabled
